import React, { useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useParams } from "react-router-dom";
// import PaymentDetails from "./PaymentDetails";
import SuccessScreen from "../Success/index";
import { useNavigate } from "react-router-dom";
import { alert } from "./../../_utilities";

const month_list = [
  { value: "", label: "MM" },
  { value: "01", label: "Jan" },
  { value: "02", label: "Feb" },
  { value: "03", label: "Mar" },
  { value: "04", label: "Apr" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "Aug" },
  { value: "09", label: "Sept" },
  { value: "10", label: "Oct" },
  { value: "11", label: "Nov" },
  { value: "12", label: "Dec" },
];

function getTenYearsList(current_year) {
  let result = [{ label: "Year", value: "" }];
  for (let i = 0; i < 10; i++) {
    result.push({ value: current_year + i, label: current_year + i });
  }
  return result;
}

function PaymentForm() {
  const [paymentData, setpaymentData] = useState({});
  const { token } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    exp_year: "",
    exp_month: "",
    card_number: "",
    cvv: "",
  });
  const [selectedValues, setSelectedValues] = useState({
    month: {},
    year: {},
  });
  const [isSubmited, setIsSubmited] = useState(false);
  const currentDate = new Date();
  const ten_years_list = getTenYearsList(currentDate.getFullYear());

  function handleSelectChange(selected, name) {
    if (name === "year") {
      let expMonth = new Date().getMonth() + 1;
      let currentYear = new Date().getFullYear();
      if (formData.exp_month) {
        if (
          (formData.exp_month > expMonth || currentYear <= selected.value) &&
          (formData.exp_month >= expMonth || currentYear < selected.value)
        ) {
          formData.exp_year = selected.value;
          selectedValues.year = selected;
          setSelectedValues({ ...selectedValues });
          setFormData(formData);
        } else {
          alert.error("Your card month is expired");
          formData.exp_year = "";
          selectedValues.year = "";
          setFormData(formData);
          setSelectedValues({ ...selectedValues });
        }
      } else {
        formData.exp_year = selected.value;
        selectedValues.year = selected;
        setSelectedValues({ ...selectedValues });
        setFormData(formData);
      }
    } else if (name === "month") {
      if (formData.exp_year) {
        let expMonth = new Date().getMonth() + 1;
        let currentYear = new Date().getFullYear();
        if (
          ((formData.exp_year > currentYear || expMonth <= selected.value) &&
            (formData.exp_year >= currentYear || expMonth < selected.value)) ||
          formData.exp_year > currentYear
        ) {
          formData.exp_month = selected.value;
          selectedValues.month = selected;
          setSelectedValues({ ...selectedValues });
          setFormData(formData);
        } else {
          alert.error("Your card month is expired");
          formData.exp_month = "";
          selectedValues.month = "";
          setFormData(formData);
          setSelectedValues({ ...selectedValues });
        }
      } else {
        formData.exp_month = selected.value;
        selectedValues.month = selected;
        setSelectedValues({ ...selectedValues });
        setFormData(formData);
      }
    }
  }

  const navigate = useNavigate();

  function handleChange(e) {
    const { value, name } = e.target;
    if (name === "card_number") {
      const inputVal = value.replace(/ /g, "");
      let inputNumbersOnly = inputVal.replace(/\D/g, "");

      if (inputNumbersOnly.length > 16) {
        inputNumbersOnly = inputNumbersOnly.substr(0, 16);
      }
      const splits = inputNumbersOnly.match(/.{1,4}/g);

      let spacedNumber = "";
      if (splits) {
        spacedNumber = splits.join(" ");
      }

      formData[name] = spacedNumber;
      setFormData({ ...formData });
    } else {
      formData[name] = value;
      setFormData({ ...formData });
    }
  }

  function validateFormData(isSubmited) {
    let obj = { message: "", isValid: true };
    let isValid = true;
    let validationData = {
      name: obj,
      card_number: obj,
      month: obj,
      year: obj,
      cvv: obj,
    };
    if (isSubmited) {
      if (!formData.name) {
        validationData.name = {
          message: "Name is required",
          isValid: false,
        };
        isValid = false;
      }
      if (!formData.card_number) {
        validationData.card_number = {
          isValid: false,
          message: "Card number is required",
        };
        isValid = false;
      } else if (
        formData.card_number &&
        !validateNumber(formData.card_number.replaceAll(" ", "") * 1)
      ) {
        validationData.card_number = {
          isValid: false,
          message: "Card number is digits only",
        };
        isValid = false;
      } else if (formData.card_number.length !== 19) {
        validationData.card_number = {
          isValid: false,
          message: "Please enter valid card number",
        };
        isValid = false;
      }
      if (!formData.exp_month) {
        validationData.month = {
          message: "Card expiry month is required",
          isValid: false,
        };
        isValid = false;
      }
      if (!formData.exp_year) {
        validationData.year = {
          message: "Card expiry year is required",
          isValid: false,
        };
        isValid = false;
      }
      if (!formData.cvv) {
        validationData.cvv = {
          isValid: false,
          message: "CVV is required",
        };
        isValid = false;
      } else if (formData.cvv && !validateNumber(formData.cvv)) {
        validationData.cvv = {
          isValid: false,
          message: "CVV code is digits only",
        };
        isValid = false;
      }
    }
    validationData.isValid = isValid;
    return validationData;
  }

  function validateNumber(num) {
    var re = /^[0-9]*$/;
    return re.test(num);
  }

  function handleSubmit() {
    const validate = validateFormData(true);
    setIsSubmited(true);
    if (validate.isValid) {
      GetCardToken(formData);
    }
  }

  let makeChargeWithToken = (token_for_charge) => {
    const headers = {
      "Content-Type": "application/json",
      charge: `${token_for_charge}`,
    };
    let url = `https://us-central1-love-happiness-temp.cloudfunctions.net/subscription-plans/purchased_with_id/${token}`;
    axios
      .get(url, { headers })
      .then((response) => {
        if (response.status === 201) {
          setpaymentData(response.data.data.data);
          // localStorage.setItem(
          //   "paymentData",
          //   JSON.stringify(response.data.data.data)
          // );
          navigate(`/payment-success`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function GetCardToken(userData = {}) {
    let url =
      "https://us-central1-love-happiness-temp.cloudfunctions.net/subscription-plans/card_token";
    axios
      .post(url, userData)
      .then((response) => {
        if (response.data.data.token.id) {
          makeChargeWithToken(response.data.data.token.id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  let validateForm = isSubmited ? validateFormData(isSubmited) : {};
  return (
    <div className="wrapper">
      {paymentData?.status === "succeeded" ? (
        <SuccessScreen data={paymentData} />
      ) : (
        <form>
          <div className="col">
            <div className="row">
              <label>Name</label>
              <br />
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              {validateForm?.name?.message && (
                <span>{validateForm.name.message}</span>
              )}
            </div>
            <div>
              <label>Card Number</label>
              <input
                type="text"
                maxLength={19}
                name="card_number"
                placeholder="1234-1234-1234-1234"
                value={formData.card_number}
                onChange={handleChange}
              />
              {validateForm?.card_number?.message && (
                <span>{validateForm.card_number.message}</span>
              )}
            </div>
            <div className="year-month">
              <label>Month</label>
              <Select
                value={selectedValues?.month}
                onChange={(option) => handleSelectChange(option, "month")}
                options={month_list}
                name="month"
              />
              <br />
              {validateForm?.month?.message && (
                <span>{validateForm.month.message}</span>
              )}
              <label>Year</label>
              <Select
                value={selectedValues?.year}
                onChange={(option) => handleSelectChange(option, "year")}
                options={ten_years_list}
                name="year"
              />
              {validateForm?.year?.message && (
                <span>{validateForm.year.message}</span>
              )}
              <br />
              {validateForm?.cvv?.message && (
                <span>{validateForm.cvv.message}</span>
              )}
              <label>CVV</label>
              <br />
              <input
                className="dont"
                type="text"
                placeholder="123"
                name="cvv"
                maxLength={3}
                onChange={handleChange}
              />
            </div>
          </div>
          <input
            type="button"
            className="btn-submit"
            value="Submit"
            onClick={handleSubmit}
          />
        </form>
      )}
    </div>
  );
}

export default PaymentForm;
